// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Check for updates dialog. Reuses the fnl-* bucket styling from
   addWebsiteLinkModal.css and only adds its own header, states and notes. */

.cfu-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.cfu-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.cfu-title-icon {
  color: #5616ea;
  font-size: 18px;
}

.cfu-close {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #9a9aa5;
  font-size: 18px;
  line-height: 1;
  padding: 2px 4px;
  transition: color 0.15s ease;
}

.cfu-close:hover {
  color: #2d2d2f;
}

.cfu-summary-lead {
  margin: 0 0 4px 0;
  color: #585a63;
  font-size: 0.95rem;
}

.cfu-results {
  margin-top: 8px;
}

/* Scanning / cooldown / error / all-clear states */
.cfu-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  padding: 40px 20px 44px 20px;
  background: linear-gradient(180deg, #faf9ff, #f6f4ff);
  border: 1px solid #eee9ff;
  border-radius: 12px;
  margin: 8px 0 4px 0;
}

.cfu-state-icon {
  font-size: 30px;
  color: #5616ea;
}

.cfu-state-icon-muted {
  color: #9a9aa5;
}

.cfu-state-icon-success {
  color: #43a047;
}

.cfu-state-icon-warning {
  color: #e5a300;
}

.cfu-state-title {
  margin: 4px 0 0 0;
  font-size: 1.05rem;
  color: #2d2d2f;
  font-weight: 600;
}

.cfu-state-text {
  margin: 0;
  max-width: 460px;
  color: #585a63;
  font-size: 0.92rem;
  line-height: 1.5;
}

.cfu-note {
  margin: 4px 0 0 0;
  font-size: 0.85rem;
  color: #8a5b00;
  background: #fff8e8;
  border: 1px solid #ffe6b0;
  border-radius: 10px;
  padding: 10px 12px;
}

.cfu-note-muted {
  color: #6f7078;
  background: transparent;
  border: none;
  padding: 8px 2px 0 2px;
}

/* Website-links page: action row with the freshness note sitting inline with
   the buttons, vertically centred against them. Own class rather than the
   shared .knowledge-add-buttons-row, which other pages also use. */
.knowledge-links-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.knowledge-freshness {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #6f7078;
  font-size: 0.88rem;
  margin: 0 0 0 6px;
}

.knowledge-freshness strong {
  font-weight: 600;
  color: #4a4b53;
}

.knowledge-freshness-icon {
  color: #9a9aa5;
  font-size: 13px;
}

.knowledge-freshness.is-stale {
  color: #8a5b00;
}

.knowledge-freshness.is-stale strong {
  color: #7a4f00;
}

.knowledge-freshness.is-stale .knowledge-freshness-icon {
  color: #e5a300;
}

/* Secondary action next to "Add link" — same metrics as .knowledge-add-button
   (pages/botSettings.css) so the two sit level in .knowledge-add-buttons-row. */
.knowledge-check-updates-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #ffffff;
  color: #5616ea;
  border: 1px solid #d9ccff;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 15px;
  font-weight: 600;
  min-width: 140px;
  cursor: pointer;
  transition: 0.2s ease, color 0.2s ease;
}

/* Same hover as .knowledge-add-button next to it: lift only, nothing else moves. */
.knowledge-check-updates-button:hover:not(:disabled) {
  cursor: pointer;
  transform: translateY(-2px);
}

.knowledge-check-updates-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/CheckForUpdatesModal.css"],"names":[],"mappings":"AAAA;4EAC4E;;AAE5E;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,4BAA4B;EAC5B,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;mEAEmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;gFACgF;AAChF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA,mFAAmF;AACnF;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/* Check for updates dialog. Reuses the fnl-* bucket styling from\r\n   addWebsiteLinkModal.css and only adds its own header, states and notes. */\r\n\r\n.cfu-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.cfu-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.cfu-title-icon {\r\n  color: #5616ea;\r\n  font-size: 18px;\r\n}\r\n\r\n.cfu-close {\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #9a9aa5;\r\n  font-size: 18px;\r\n  line-height: 1;\r\n  padding: 2px 4px;\r\n  transition: color 0.15s ease;\r\n}\r\n\r\n.cfu-close:hover {\r\n  color: #2d2d2f;\r\n}\r\n\r\n.cfu-summary-lead {\r\n  margin: 0 0 4px 0;\r\n  color: #585a63;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.cfu-results {\r\n  margin-top: 8px;\r\n}\r\n\r\n/* Scanning / cooldown / error / all-clear states */\r\n.cfu-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: 10px;\r\n  padding: 40px 20px 44px 20px;\r\n  background: linear-gradient(180deg, #faf9ff, #f6f4ff);\r\n  border: 1px solid #eee9ff;\r\n  border-radius: 12px;\r\n  margin: 8px 0 4px 0;\r\n}\r\n\r\n.cfu-state-icon {\r\n  font-size: 30px;\r\n  color: #5616ea;\r\n}\r\n\r\n.cfu-state-icon-muted {\r\n  color: #9a9aa5;\r\n}\r\n\r\n.cfu-state-icon-success {\r\n  color: #43a047;\r\n}\r\n\r\n.cfu-state-icon-warning {\r\n  color: #e5a300;\r\n}\r\n\r\n.cfu-state-title {\r\n  margin: 4px 0 0 0;\r\n  font-size: 1.05rem;\r\n  color: #2d2d2f;\r\n  font-weight: 600;\r\n}\r\n\r\n.cfu-state-text {\r\n  margin: 0;\r\n  max-width: 460px;\r\n  color: #585a63;\r\n  font-size: 0.92rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.cfu-note {\r\n  margin: 4px 0 0 0;\r\n  font-size: 0.85rem;\r\n  color: #8a5b00;\r\n  background: #fff8e8;\r\n  border: 1px solid #ffe6b0;\r\n  border-radius: 10px;\r\n  padding: 10px 12px;\r\n}\r\n\r\n.cfu-note-muted {\r\n  color: #6f7078;\r\n  background: transparent;\r\n  border: none;\r\n  padding: 8px 2px 0 2px;\r\n}\r\n\r\n/* Website-links page: action row with the freshness note sitting inline with\r\n   the buttons, vertically centred against them. Own class rather than the\r\n   shared .knowledge-add-buttons-row, which other pages also use. */\r\n.knowledge-links-actions {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.knowledge-freshness {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: #6f7078;\r\n  font-size: 0.88rem;\r\n  margin: 0 0 0 6px;\r\n}\r\n\r\n.knowledge-freshness strong {\r\n  font-weight: 600;\r\n  color: #4a4b53;\r\n}\r\n\r\n.knowledge-freshness-icon {\r\n  color: #9a9aa5;\r\n  font-size: 13px;\r\n}\r\n\r\n.knowledge-freshness.is-stale {\r\n  color: #8a5b00;\r\n}\r\n\r\n.knowledge-freshness.is-stale strong {\r\n  color: #7a4f00;\r\n}\r\n\r\n.knowledge-freshness.is-stale .knowledge-freshness-icon {\r\n  color: #e5a300;\r\n}\r\n\r\n/* Secondary action next to \"Add link\" — same metrics as .knowledge-add-button\r\n   (pages/botSettings.css) so the two sit level in .knowledge-add-buttons-row. */\r\n.knowledge-check-updates-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  background: #ffffff;\r\n  color: #5616ea;\r\n  border: 1px solid #d9ccff;\r\n  border-radius: 8px;\r\n  padding: 8px 14px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  min-width: 140px;\r\n  cursor: pointer;\r\n  transition: 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n/* Same hover as .knowledge-add-button next to it: lift only, nothing else moves. */\r\n.knowledge-check-updates-button:hover:not(:disabled) {\r\n  cursor: pointer;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.knowledge-check-updates-button:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
